export default "__VITE_ASSET__DZvmVd0k__"